import { render, staticRenderFns } from "./SubmitFeedback.vue?vue&type=template&id=866fd80e&scoped=true"
import script from "./SubmitFeedback.vue?vue&type=script&lang=js"
export * from "./SubmitFeedback.vue?vue&type=script&lang=js"
import style0 from "./SubmitFeedback.vue?vue&type=style&index=0&id=866fd80e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866fd80e",
  null
  
)

export default component.exports